<div id="app-chart-legend" class="bold">
  <div *ngFor="let label of labels">
    <div appStatusIndicator [ngStyle]="getStyle(label)"></div>
    {{ label.text }}
  </div>
</div>
